var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-link-alt.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.81466 13.6851C3.12391 13.9948 3.49131 14.2404 3.89574 14.4076C4.30017 14.5749 4.73367 14.6606 5.17133 14.6598C5.60908 14.6606 6.04267 14.5749 6.44721 14.4076C6.85175 14.2403 7.21927 13.9948 7.52866 13.6851L9.41399 11.7991L8.47133 10.8565L6.58599 12.7425C6.21031 13.1165 5.70178 13.3265 5.17166 13.3265C4.64155 13.3265 4.13301 13.1165 3.75733 12.7425C3.383 12.367 3.1728 11.8584 3.1728 11.3281C3.1728 10.7979 3.383 10.2893 3.75733 9.91381L5.64333 8.02848L4.70066 7.08581L2.81466 8.97115C2.19053 9.59678 1.84003 10.4444 1.84003 11.3281C1.84003 12.2119 2.19053 13.0595 2.81466 13.6851ZM13.1853 8.02848C13.8091 7.40267 14.1594 6.55509 14.1594 5.67148C14.1594 4.78787 13.8091 3.94029 13.1853 3.31448C12.5597 2.69035 11.712 2.33984 10.8283 2.33984C9.94461 2.33984 9.09697 2.69035 8.47133 3.31448L6.58599 5.20048L7.52866 6.14315L9.41399 4.25715C9.78968 3.88314 10.2982 3.67316 10.8283 3.67316C11.3584 3.67316 11.867 3.88314 12.2427 4.25715C12.617 4.63266 12.8272 5.14126 12.8272 5.67148C12.8272 6.2017 12.617 6.7103 12.2427 7.08581L10.3567 8.97115L11.2993 9.91381L13.1853 8.02848Z",
    fill: "#636D65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.64267 11.7992L4.69934 10.8566L10.3573 5.19922L11.3 6.14255L5.64267 11.7992Z",
    fill: "#636D65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.8c978bee86ebc0e412b6543376a76828.svg";
export { ForwardRef as ReactComponent };